import api from 'services/api'
import { ICategory } from 'types/Category.types'

export class CategoryService {
  getCategories = () => api.get<ICategory[]>('category')

  postCategory = (category: ICategory) => api.post<ICategory>('category', category)
}
